module.exports = __webpack_public_path__ + "img/stat.24a55027.svg";